import React from 'react';
import { ManageReference } from '../ManageReference/ManageReference';
import { getAllActivitiesUrl } from '../../../helpers/constants';


export function ManageActivities() {
	return (
		<ManageReference
			title="Управление опасными факторами"
			endpoint={getAllActivitiesUrl}
			labels={{
				selectLabel: 'Опасные факторы:',
				boxTitle: 'Параметры опасного фактора',
				createNew: '---Создать новый опасный фактор---'
			}}
		/>
	);
}